// extracted by mini-css-extract-plugin
module.exports = {"even":"statistic_even__uVQFD","title":"statistic_title__39R7N","odd":"statistic_odd__1tn1h"};